import { render, staticRenderFns } from "./TenantDetailsView.vue?vue&type=template&id=02b86f97&scoped=true"
import script from "./TenantDetailsView.vue?vue&type=script&lang=js"
export * from "./TenantDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b86f97",
  null
  
)

export default component.exports